import errorMessages from "utils/validation/errorMessages";
import { emailSchema, optionalPasswordSchema, phoneRequiredSchema, select2OptionalSchema, select2RequiredSchema, statusSchema, stringOptionalSchema, stringRequiredSchema, urlRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const addSubAdminSchema = object().shape({
    firstname: stringRequiredSchema,
    lastname: stringRequiredSchema,
    phone: phoneRequiredSchema,
    email: emailSchema,
    password: optionalPasswordSchema,
    self_description: stringOptionalSchema,
    profile_picture: stringOptionalSchema.url(errorMessages.url),
    email_signature: stringOptionalSchema,
    signature_img: stringOptionalSchema.url(errorMessages.url),
});

export default addSubAdminSchema;